import store from "@/store";
import globalMethods from "@/global-methods";
import { endpoints } from "@/constants/endpoints";
import { partTypeStrings } from "@/constants/part-type-strings";
import { storeActions } from "@/constants/store-actions";
import { selectedPolicyVehicleHasOemEndorsement } from "@/helpers/endorsements-helper";

export function buildRevisitPartSelectionRequest({ isOemEndorsed } = {}) {
    const order = store.getters.order;

    return {
        isOemRequest: false,
        isOemEndorsed: isOemEndorsed ?? selectedPolicyVehicleHasOemEndorsement(order),
        customerZipCode: order?.serviceLocation?.zipCode,
        accountNumber: order?.payment?.parentAccountNumber,
        carId: order?.vehicle?.carId,
        billToAccountNumber: order?.payment?.billToAccountNumber,
        vin: order?.vehicle?.vin,
        partsList: order?.lineItems?.glassParts ?? [],
    };
}

export async function callRevisitPartSelection({ pageNameToLog, isOemEndorsed } = {}) {
    const payload = buildRevisitPartSelectionRequest({ isOemEndorsed });

    const response = await globalMethods.callHttpClient({
        method: endpoints.RevisitPartSelection.method,
        endpoint: endpoints.RevisitPartSelection.url,
        payload,
        logApiCall: true,
        pageNameToLog,
    });

    return response?.data;
}

function getWindshieldPartNumber(partsList = []) {
    return partsList.find((part) => part.partType === partTypeStrings.WINDSHIELD)?.partNumber;
}

export async function handleRevisitPartSelectionResponse(response, requestPartsList) {
    if (response?.isPartsCountMismatch) {
        return { redirectToVehicleDamage: true };
    }

    const requestWindshieldPartNumber = getWindshieldPartNumber(requestPartsList);
    const responseWindshieldPartNumber = getWindshieldPartNumber(response?.partsList);

    const shouldReplaceGlassParts =
        !response?.isPartsCountMismatch &&
        requestWindshieldPartNumber !== responseWindshieldPartNumber;

    if (shouldReplaceGlassParts) {
        await store.dispatch(storeActions.SAVE_GLASS_PARTS, response.partsList);
    }

    return { redirectToVehicleDamage: false };
}

export async function requestOemPartsIfEndorsed({ pageNameToLog } = {}) {
    const order = store.getters.order;
    const requestPartsList = order?.lineItems?.glassParts ?? [];
    if (!selectedPolicyVehicleHasOemEndorsement(order) || requestPartsList.length === 0) {
        return;
    }

    try {
        const response = await callRevisitPartSelection({ pageNameToLog });
        return handleRevisitPartSelectionResponse(response, requestPartsList);
    } catch {
        // OEM part replacement should not block C&C navigation.
    }
}
